import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import api, { apiAction } from '../../api'
import { withRouter } from 'react-router-dom'

import { password, required } from '../../common/validators'
import useModel from '../../common/useModel'
import S from './styled'
import { getTheme } from '../../themes'

import {
  Input,
  Button,
} from  '../../components'

const theme = getTheme()

const defaultModel = {
  values: {
    username: '',
    password: '',
  },
}

const LoginForm = ({ createRoot, createRootError, history, creatingRoot }) => {

  const { model, text } = useModel(defaultModel)
  const canSubmit = model.values.password

  const onSubmit = useCallback(event => {
    event.preventDefault()
    event.stopPropagation()
    if (canSubmit && !creatingRoot) {
      createRoot(model.values.password).then(payload => {
        window.location.hash = '#/login'
        window.location.reload()
      })
    }
    return false
  }, [canSubmit, creatingRoot, createRoot, model.values.password])

  const validateConfirm = useCallback(value => value === model.values.password ? null : 'Password not match', [model.values.password])

  return (
    <S.FormContainer>
      <img src={theme.logoFull} alt="Logo"/>
      <form onSubmit={onSubmit} autoComplete="off" className="passwordInput">
        <Input {...{
          name: 'values.password', text,
          title: 'Enter new root password',
          inverted: true,
          validate: [password, required],
          autoFocus: true,
        }}/>
        <Input {...{
          name: 'values.repeatpassword', text,
          title: 'Confirm password',
          inverted: true,
          validate: [required, validateConfirm],
          autoFocus: true,
        }}/>
        { createRootError && <S.ErrorLabel>{createRootError}</S.ErrorLabel> }
        <Button
          onClick={creatingRoot ? null : onSubmit}
          disabled={creatingRoot ? false : !canSubmit || !model.isValid}
          progress={creatingRoot}>
          {creatingRoot ? 'Submitting...' : 'Submit'}
        </Button>
      </form>
    </S.FormContainer>
  )
}

const mapStateToProps = state => ({
  creatingRoot: state.session.creatingRoot,
  createRootError: state.session.createRootError,
})

const mapDispatchToProps = dispatch => ({
  createRoot: password => dispatch(apiAction(api.createRoot)({ password }, { quite: true })),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginForm))
